import Popup from 'reactjs-popup';
import TemplateCardImage from '../../../assets/icons/templateCard.svg';
import TripleDotsImage from '../../../assets/icons/tripleDots.svg';
import 'reactjs-popup/dist/index.css';

import './scheduleTemplateCard.scss';
import HolidaySelectionModal from '../holidaySelectionModal/holidaySelectionModal';

interface IBadgeProps {
    type: string;
}

interface ITemplateCardProps {
    type: string;
    name: string;
    hours?: string;
}

const Badge = ({ type }: IBadgeProps) => {
    if (type == '고정근무') {
        return <div className="workCard">고정근무</div>;
    } else if (type == '선택적근무') {
        return <div className="workCardSelective">선택적근무</div>;
    } else if (type == '자율출퇴근') {
        return <div className="workCardAutonomous">자율출퇴근</div>;
    }
    return <></>;
};

const TemplateCard = ({ type, name, hours }: ITemplateCardProps) => {
    return (
        <>
           

            <div className="scheduleTemplateCard">
                <div className="headerRow">
                    <div className="titleContainer">
                        <div className="image">
                            <img src={TemplateCardImage} alt="" />
                        </div>
                        <div className="text">{name}</div>
                    </div>
                    <div className="dropDown">
                        <Popup
                            trigger={<img src={TripleDotsImage} alt="" />}
                            position="right top"
                            className="templateCardPopupContent"
                        >
                            <div className="templateCardPopupContent">
                                <div className="templateCardPopupContentMenuItem">수정</div>

                                <div className="templateCardPopupContentMenuItem">
                                    삭제</div>
                            </div>
                        </Popup>
                    </div>
                </div>

                <div className="dataContainer">
                    <div className="type">
                        <div className="header">근무형태</div>
                        <div className="data">
                            <Badge type={type} />{' '}
                        </div>
                    </div>
                    <div className="hours">
                        <div className="header">근무시간</div>
                        <div className="data">{hours}</div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TemplateCard;
